import { useTheme } from 'styled-components';
import {
  Button,
  Footer,
  Icon,
  Text,
  Toolbar,
  ToolbarItem,
} from '@kinesis/bungle';

// Store-less footer that appears whenever the user has pending edits
// on a disclosure. Mirrors suit's `disclosure-save-bar.tsx` verbatim —
// info icon + message + Discard/Save buttons, where Save is hidden for
// non-editor viewers. The page owns `hasChanges` and only mounts this
// component when it's true; saving / discarding the changes is the
// caller's responsibility.

const DisclosureSaveBar = (props: DisclosureSaveBarProps) => {
  const { isEditor, onSave, onDiscard } = props;
  const theme = useTheme() as any;
  return (
    <Footer border shadow>
      <Toolbar>
        <ToolbarItem>
          <Icon type='info-circle' color={theme.color.yellow6} />
        </ToolbarItem>
        <ToolbarItem ellipsify>
          {isEditor ? (
            <Text>Save your changes to make them visible to others.</Text>
          ) : (
            <Text>
              You have view only access to this inventory and are not able to
              save changes.
            </Text>
          )}
        </ToolbarItem>
        <ToolbarItem>
          <Button variant='secondary' onClick={onDiscard}>
            Discard changes
          </Button>
        </ToolbarItem>
        {isEditor && (
          <ToolbarItem>
            <Button variant='primary' onClick={onSave}>
              Save changes
            </Button>
          </ToolbarItem>
        )}
      </Toolbar>
    </Footer>
  );
};

type DisclosureSaveBarProps = {
  isEditor: boolean;
  onSave: () => void;
  onDiscard: () => void;
};

export type { DisclosureSaveBarProps };
export { DisclosureSaveBar };
